import React, { memo, useCallback, useMemo } from 'react';
import Animated from 'react-native-reanimated';
import { rem, Button, AppView, CardView, ButtonGroup, SCROLL_INDICATOR_INSETS, withAnimatedNavigationHeader, } from 'design-system';
import StatusBar from 'design-system/StatusBar';
import { useUserAddress } from 'hooks/useUserAddress';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import AddressDisplay from './components/AddressDisplay';
import AddressKYCStatus from './components/AddressKYCStatus';
import { isWeb } from '../../../constants';
const strings = {
    changeBtn: 'Change address',
    verifyAddressBtn: 'Verify address',
};
const AddressInfoWithStatusScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const { primaryAddress } = useUserAddress(true);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const paddingBtnWithOneBtn = useMarginBottom('paddingBottom', rem(56 + 16));
    const paddingBtnWithTwoBtns = useMarginBottom('paddingBottom', rem(56 + 56 + 8 + 16));
    const contentContainerStyles = useMemo(() => [
        !primaryAddress?.kycStatus
            ? paddingBtnWithTwoBtns
            : paddingBtnWithOneBtn,
        paddingHorizontalStyle,
    ], [
        paddingBtnWithOneBtn,
        paddingBtnWithTwoBtns,
        paddingHorizontalStyle,
        primaryAddress?.kycStatus,
    ]);
    const handleVerifyAddress = useCallback(() => {
        if (primaryAddress) {
            navigation.push('ChangeAddressProgressScreen', {
                flow: 'VERIFY',
                address: primaryAddress,
            });
        }
    }, [primaryAddress]);
    const handleChangeAddress = useCallback(() => {
        navigation.push('ChangeAddressProgressScreen', {
            flow: 'CHANGE',
        });
    }, []);
    return (<AppView type="secondary" withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} contentContainerStyle={contentContainerStyles} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
            <AddressKYCStatus address={primaryAddress}/>

            {!!primaryAddress && (<CardView noMarginTop noMarginBottom webPadding>
                <AddressDisplay address={primaryAddress}/>
              </CardView>)}
          </Animated.ScrollView>
          <ButtonGroup type="floating">
            {Boolean(!primaryAddress?.kycStatus &&
            primaryAddress?.countryIsoCode === 'GB') && (<Button brandReversed onPress={handleVerifyAddress} title={strings.verifyAddressBtn}/>)}
            <Button title={strings.changeBtn} brand onPress={handleChangeAddress}/>
          </ButtonGroup>
        </AppView>);
}, ({ colors }) => ({
    title: 'Address',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default memo(AddressInfoWithStatusScreen);
